/* eslint-disable react/prop-types */
import React, { useState, useMemo } from 'react';

import { Form } from '@unform/web';
import PrintBasket from '~/assets/img/imprimir_conta.svg';

import ReactToPrint from 'react-to-print';

import { FaCashRegister, FaEye, FaPrint } from 'react-icons/fa';
import { BiTransfer } from 'react-icons/bi';

import { toast } from 'react-hot-toast';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';

import { FiX } from 'react-icons/fi';
import Cart from '~/components/OrderingSystem/Cart';
import DefaultButton from '~/components/Buttons/DefaultButton';
import { useAuth } from '~/context/AuthContext';
import { useCart } from '~/context/OrderingSystem/Cart';
import { default as api } from '~/services/api2';
import Menu from '~/pages/OrderingSystem/Menu';
import EyeOrdersBillOperation from '~/components/Tables/EyeOrdersBillOperation';
import Input from '~/components/Form/Input';
import { Button } from 'ui-kit-takeat';
import { ModalConfirmation } from '~/components/ModalConfirmation';
import history from '~/services/history';
import {
  Input as NewInput,
  Button as NewButton,
  NotificationBanner,
} from 'takeat-design-system-ui-kit';
import PrePaidExtract from './PrePaidExtract';
import { ButtonAloneArea } from '../TableOperation/styles';
import {
  Content,
  OperationArea,
  OrderSystemArea,
  BillTableArea,
  ButtonsArea,
  RegisterBuyerHeader,
  RegisterBuyerBody,
  RegisterBuyerInputDiv,
  RegisterBuyerBottom,
} from './styles';

function TableAvailable({
  session,
  getMinimalSessions,
  setMinimalSessions,
  inicialDate,
  finalDate,
  type,
  getTablesAvailable,
  sessionId,
  handleSearchInputTables,
  setCount,
  setInputValue,
  setTablesFilteredSearch,
  setAllTablesAvailable,
  // paymentMethods,
  handleUpdate,
  ...props
}) {
  const {
    user,
    setWaiterId,
    setBuyerCreatedByWaiter,
    setBuyerSelectedByWaiter,
  } = useAuth();
  const { closeCart, cart } = useCart();
  const [discountObs, setDiscountObs] = useState(null);
  const [discount, setDiscount] = useState(null);
  const [modalAdvice, setModalAdvice] = useState(false);
  const [client, setClient] = useState(null);

  const [responseNfce, setResponseNfce] = useState(null);
  const [nfWarning, setNFWarning] = useState(false);

  const [buyerName, setBuyerName] = useState('');
  const [buyerPhone, setBuyerPhone] = useState('');

  function toggleModalAdvice() {
    setModalAdvice(!modalAdvice);
  }

  const [isModalOperationOpened, setIsModalOperationOpened] = useState(false);
  const [isModalVerifyPasswordOpened, setIsModalVerifyPasswordOpened] =
    useState(false);

  async function toggleModalOperation() {
    if (cart.length > 0) {
      setModalAdvice(true);
    } else if (client) {
      if (window.confirm('Deseja abrir uma comanda vazia com esse cliente?')) {
        try {
          const data = {
            client_id: client.id,
            table_number: session.table_number,
          };

          await api.post('restaurants/clients/create-session', data);

          toast.success('Comanda aberta com cliente!');
          getMinimalSessions();
          getTablesAvailable();
          setIsModalOperationOpened(!isModalOperationOpened);
          closeCart();
        } catch (err) {
          toast.error(err.response.data.message || 'Erro ao abrir comanda');
          setIsModalOperationOpened(!isModalOperationOpened);
          closeCart();
          console.log(err);
        }
      } else {
        setIsModalOperationOpened(!isModalOperationOpened);
        closeCart();
      }
    } else {
      setIsModalOperationOpened(!isModalOperationOpened);
      closeCart();
    }
  }

  function confirmCloseCart() {
    setIsModalOperationOpened(!isModalOperationOpened);
    toggleModalAdvice();
    closeCart();
  }

  function toggleModalVerifyPassword() {
    if (isModalOperationOpened) {
      setIsModalVerifyPasswordOpened(false);
    } else {
      setIsModalVerifyPasswordOpened(!isModalVerifyPasswordOpened);
      setTimeout(() => {
        return document.getElementById('input_waiter_password')?.focus();
      }, 1);
    }
  }

  const [modalEyeOpen, setModalEyeOpen] = useState(false);
  function toggleEyeOpen() {
    setModalEyeOpen(!modalEyeOpen);
  }

  const [modalBuyerRegisterOpen, setModalBuyerRegisterOpen] = useState(false);
  function toggleBuyerRegister() {
    setModalBuyerRegisterOpen(!modalBuyerRegisterOpen);
  }

  const tableId =
    session?.status !== 'available' ? session?.table?.id : session?.id;
  const tableNumber =
    session?.status !== 'available'
      ? session?.table?.table_number
      : session?.table_number;

  function verifyWaiterPassword() {
    setBuyerCreatedByWaiter('');
    setBuyerSelectedByWaiter('');
    if (user.ask_waiter_key && user?.is_pdv) {
      toggleModalVerifyPassword();
    } else {
      setIsModalOperationOpened(true);
    }
  }

  async function verifyWaiterPasswordAccepted(data) {
    try {
      const response = await api.get(
        `/restaurants/verify-waiter-key/${data.pdv_key}`
      );

      if (response.data.id) {
        setIsModalOperationOpened(true);
        setWaiterId(response.data.id);
        toggleModalVerifyPassword();
      }
    } catch (error) {
      toast.error('Senha invalida');
    }
  }

  const [errorCreateSessionWithBuyer, setErrorCreateSessionWithBuyer] =
    useState(null);
  const [loadingCreateSessionWithBuyer, setLoadingCreateSessionWithBuyer] =
    useState(false);

  async function createSessionWithBuyer() {
    setLoadingCreateSessionWithBuyer(true);
    setErrorCreateSessionWithBuyer(null);
    try {
      if (buyerName === '') {
        setErrorCreateSessionWithBuyer('Insira o nome do cliente');
        setLoadingCreateSessionWithBuyer(false);
        return;
      }

      if (buyerPhone.length !== 15) {
        setErrorCreateSessionWithBuyer('Insira um telefone válido');
        setLoadingCreateSessionWithBuyer(false);
        return;
      }

      await api.post('/restaurants/buyer/create-session', {
        table_id: session.id,
        name: buyerName,
        phone: buyerPhone,
      });

      handleSearchInputTables('');
      setInputValue('');
      getMinimalSessions();
      getTablesAvailable();
      toggleBuyerRegister();
    } catch (error) {
      if (error?.response?.data?.message) {
        setErrorCreateSessionWithBuyer(error.response.data.message);
      } else {
        toast.error('Erro ao abrir comanda');
      }
    }
    setLoadingCreateSessionWithBuyer(false);
  }

  function searchTableName(table) {
    if (table.table_type === 'balcony') {
      return 'Balcão';
    }

    if (table.table_type === 'pos') {
      return 'POS';
    }

    if (table?.table_type === 'self-service') {
      return 'Totem';
    }

    if (table.table_type === 'delivery') {
      return 'Delivery';
    }

    if (table.table_type === 'command') {
      return `Comanda ${table.table_number}`;
    }

    if (table.table_number === -10) {
      return 'Mesa Copa';
    }

    return `Mesa ${table.table_number}`;
  }

  const [isModalExtractOpened, setIsModalExtractOpened] = useState(false);

  function toggleExtract() {
    setIsModalExtractOpened(!isModalExtractOpened);
  }

  const browserZoomLevel = Math.round(window.devicePixelRatio * 100);

  // Memoize the arrayBalconyMode array to prevent recreation on every render
  const arrayBalconyMode = useMemo(
    () => [
      2, 70494, 68349, 47757, 45348, 64818, 69372, 3933, 68778, 53532, 32841,
      7436, 56304, 203, 7794, 7629, 69504, 60198, 45282, 67326, 39012, 68844,
      48846, 47296, 49869, 24954, 72078, 19377, 43929, 67722, 51651, 59373,
      49671, 38121, 54291, 51618, 41058, 38715, 40893, 66832, 71418, 7827, 7200,
      8257, 55974, 70461, 56700, 33138, 19, 68118, 64851, 54357, 62376, 51519,
      47163, 46371, 36735, 64686, 65049, 9873, 17892, 36108, 38781, 22314,
      33204, 43533, 52410, 48384, 2715, 36009, 53070, 35382, 3111, 58087, 43335,
      29838, 61188, 465, 70692, 47526, 4956, 68184, 58053, 48285, 51915, 10731,
      41817, 56238, 15879, 54621, 63498, 26109, 40168, 67458, 52344, 67260,
      65379, 67788, 8884, 31818,
    ],
    []
  );

  function onClickFunction() {
    if (type === 'balcony' && arrayBalconyMode.includes(user.id)) {
      if (session?.status === 'available') {
        history.push('/balcony');
      } else {
        verifyWaiterPassword();
      }

      return;
    }

    if (user?.use_tablet_with_qr_code && session?.status === 'available') {
      setModalBuyerRegisterOpen(true);
      return;
    }

    if (type === 'prepaid') {
      toggleExtract();
    } else {
      verifyWaiterPassword();
    }
  }
  
  return (
    <Content
      type={type}
      nullTable={session?.status}
      // onClick={type === 'prepaid' ? toggleExtract : verifyWaiterPassword}
      onClick={onClickFunction}
      {...props}
    >
      {session?.status !== 'available' ? (
        <p>{session?.table?.table_number}</p>
      ) : (
        <p>
          {session?.table_type === 'balcony'
            ? 'Balcão'
            : session?.table_number === -10
            ? 'Copa'
            : session?.table_number}
        </p>
      )}

      {type === 'prepaid' && (
        <p style={{ fontSize: 12, textAlign: 'center' }}>
          Pagamento Antecipado
        </p>
      )}

      {type === 'lounge' && (
        <p style={{ fontSize: 12, textAlign: 'center' }}>Lounge</p>
      )}

      {isModalExtractOpened && (
        <Modal isOpen={isModalExtractOpened} toggle={toggleExtract}>
          <div style={{ maxHeight: '600px', overflow: 'auto' }}>
            <span style={{ float: 'right', padding: 10 }}>
              <FiX
                color="#FF2B3A"
                size={22}
                cursor="pointer"
                onClick={toggleExtract}
              />
            </span>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: 30,
              }}
            >
              <p
                style={{
                  textAlign: 'center',
                  color: '#FF2B3A',
                  marginLeft: 40,
                }}
              >
                Pagamento Antecipado
              </p>
              <h4
                style={{
                  textAlign: 'center',
                  color: '#FF2B3A',
                  fontWeight: 'bold',
                  marginLeft: 40,
                }}
              >
                Mesa{' '}
                {session.table_number === -4
                  ? 'POS'
                  : session.table_number === -5
                  ? 'Totem'
                  : session.table_number}
              </h4>
            </div>

            <ModalBody>
              <PrePaidExtract tableId={session?.id} />
            </ModalBody>

            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                paddingRight: 25,
              }}
            >
              <DefaultButton onClick={toggleExtract} message="Sair" />
            </div>
          </div>
        </Modal>
      )}

      {modalBuyerRegisterOpen && (
        <Modal isOpen={modalBuyerRegisterOpen} toggle={toggleBuyerRegister}>
          <RegisterBuyerHeader>
            <h1>Adicionar Cliente</h1>
            <h2>Informe os dados do cliente para vincular à comanda.</h2>
          </RegisterBuyerHeader>
          <RegisterBuyerBody>
            <RegisterBuyerInputDiv>
              <NewInput
                name="name"
                label="Nome do Cliente*"
                placeholder="Digite o nome"
                style={{ width: '100%' }}
                onChange={(e) => setBuyerName(e.target.value)}
              />
            </RegisterBuyerInputDiv>

            <RegisterBuyerInputDiv style={{ flexDirection: 'row', gap: '8px' }}>
              <NewInput
                name="phone"
                label="Celular*"
                mask="(99) 99999-9999"
                placeholder="(00) 00000-0000"
                style={{ width: '100%' }}
                onChange={(e) => setBuyerPhone(e.target.value)}
              />

              <NewInput
                name="command_number"
                label="Número da Comanda"
                value={session?.table?.table_number || session?.table_number}
                style={{ width: '100%' }}
                disabled
              />
            </RegisterBuyerInputDiv>

            <RegisterBuyerInputDiv>
              {errorCreateSessionWithBuyer && (
                <NotificationBanner
                  isOpen
                  // onClose={function ra(){}}
                  variant="error"
                  style={{ width: '100%' }}
                >
                  <div style={{ color: '#545454' }}>
                    {errorCreateSessionWithBuyer}
                  </div>
                </NotificationBanner>
              )}
            </RegisterBuyerInputDiv>
          </RegisterBuyerBody>
          <RegisterBuyerBottom>
            <NewButton
              variant="default"
              name="button_cancel"
              onClick={() => toggleBuyerRegister()}
            >
              Cancelar
            </NewButton>

            <NewButton
              variant="default"
              customColor="#2EC9B7"
              name="button_confirm"
              onClick={() => createSessionWithBuyer()}
              disabled={loadingCreateSessionWithBuyer}
            >
              Abrir comanda
            </NewButton>
          </RegisterBuyerBottom>
        </Modal>
      )}

      <ModalConfirmation
        isOpen={modalAdvice}
        toggle={toggleModalAdvice}
        confirm={confirmCloseCart}
        confirmText="Sim, sair e excluir o carrinho"
        cancel={toggleModalAdvice}
        cancelText="Irei fazer o pedido"
        title="Você possui itens no carrinho. Tem certeza que deseja sair sem fazer o pedido?"
      />

      {isModalVerifyPasswordOpened && (
        <Modal
          isOpen={isModalVerifyPasswordOpened}
          toggle={toggleModalVerifyPassword}
        >
          <Form onSubmit={verifyWaiterPasswordAccepted}>
            <ModalBody>
              <Input
                label="Senha de acesso do garçom as mesas do PDV."
                name="pdv_key"
                type="password"
                id="input_waiter_password"
                maxlength={3}
                onChange={(e) => {
                  if (e.target.value.length === 3) {
                    verifyWaiterPasswordAccepted({ pdv_key: e.target.value });
                  }
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button
                title="Validar senha"
                buttonColor="#7fd1b9"
                type="submit"
                onClick={() => {}}
              />
              <Button
                title="Cancelar"
                onClick={(e) => {
                  e.preventDefault();
                  toggleModalVerifyPassword();
                }}
                buttonColor="#dc3545"
              />
            </ModalFooter>
          </Form>
        </Modal>
      )}

      {isModalOperationOpened && (
        <Modal
          isOpen={isModalOperationOpened}
          toggle={toggleModalOperation}
          size="takeat"
        >
          <ModalBody>
            <OperationArea browserZoomLevel={browserZoomLevel}>
              <OrderSystemArea browserZoomLevel={browserZoomLevel}>
                <Menu
                  tableId={tableId}
                  getTablesAvailable={getTablesAvailable}
                  getSessions={getMinimalSessions}
                  session={sessionId}
                  handleSearchInputTables={handleSearchInputTables}
                  setInputValue={setInputValue}
                  setTablesFilteredSearch={setTablesFilteredSearch}
                  setAllTablesAvailable={setAllTablesAvailable}
                  client={client}
                  tableNumber={tableNumber}
                  isTableDelivery={false}
                  tableType={session?.table_type}
                  // paymentMethods={paymentMethods}
                  responseNfce={responseNfce}
                  setResponseNfce={setResponseNfce}
                  nfWarning={nfWarning}
                  setNFWarning={setNFWarning}
                  setIsModalOperationOpened={setIsModalOperationOpened}
                  handleUpdate={handleUpdate}
                  tableSession={session}
                />
              </OrderSystemArea>

              <BillTableArea browserZoomLevel={browserZoomLevel}>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <h2
                    style={{
                      fontWeight: 600,
                      margin: 0,
                    }}
                  >
                    {searchTableName(session)}
                  </h2>{' '}
                  <span
                    style={{
                      fontWeight: 'bold',
                      fontSize: 20,
                      paddingRight: 10,
                    }}
                  >
                    Carrinho
                  </span>
                </div>
                <Cart
                  isTableDelivery={false}
                  isBalcony={session?.table_type === 'balcony'}
                  confirmCloseCart={confirmCloseCart}
                  setDiscount={setDiscount}
                  setDiscountObs={setDiscountObs}
                  discount={discount}
                  discountObs={discountObs}
                  isAvailable
                  setClientOperation={setClient}
                />
                <EyeOrdersBillOperation
                  sessionId={sessionId}
                  inicialDate={inicialDate}
                  finalDate={finalDate}
                  setSessions={setMinimalSessions}
                  toggleEyeOpen={toggleEyeOpen}
                  getSessions={getMinimalSessions}
                  getTablesAvailable={getTablesAvailable}
                  session={session}
                  isAvailable
                />
                {/* <ClientArea setClient={setClient} session={session} /> */}
                <ButtonsArea>
                  {user.is_printed_on_web || user.print_bills_on_web ? (
                    <ButtonAloneArea type="closing" disabled>
                      <FaPrint size={22} color="#e9243e" />
                      Fechar
                    </ButtonAloneArea>
                  ) : (
                    <ButtonAloneArea type="closing" disabled>
                      <FaPrint size={22} color="#e9243e" />
                      Fechar
                    </ButtonAloneArea>
                  )}
                  {!user?.is_pdv && (
                    <ButtonAloneArea type="box" disabled>
                      <FaCashRegister size={22} color="#009f43" />

                      <span> Caixa</span>
                    </ButtonAloneArea>
                  )}
                  <ButtonAloneArea
                    type="details"
                    disabled
                    style={{ textAlign: 'center' }}
                  >
                    <img src={PrintBasket} sizes="22" />
                    <span style={{ lineHeight: '14px' }}>Imprimir Conta</span>
                  </ButtonAloneArea>
                  {/* <ButtonAloneArea type="discount" disabled>
                  <FaPercentage size={22} color="#7f007f" />
                  <span>Desconto</span>
                </ButtonAloneArea> */}
                  <ButtonAloneArea type="transfer" disabled>
                    <BiTransfer size={22} color="#ffbb2f" />
                    <span style={{ textAlign: 'center', lineHeight: '14px' }}>
                      Transf. Mesa
                    </span>
                  </ButtonAloneArea>
                </ButtonsArea>
              </BillTableArea>
            </OperationArea>
          </ModalBody>
        </Modal>
      )}

      {nfWarning && (
        <Modal isOpen={nfWarning}>
          <ModalBody>
            <p>
              Ocorreu um erro ao tentar emitir a Nota Fiscal. Corrija-o e tente
              novamente!
            </p>
            <p>Erro(s):</p>
            {responseNfce?.status_sefaz === '100' ? (
              <p style={{ color: 'green' }}>
                Mensagem SEFAZ: {responseNfce?.mensagem_sefaz}
              </p>
            ) : (
              <div style={{ color: 'red' }}>
                <p style={{ color: 'red' }}>
                  Mensagem SEFAZ:{' '}
                  {responseNfce?.response
                    ? responseNfce?.response.mensagem
                    : responseNfce?.mensagem_sefaz}
                </p>
                {responseNfce?.response &&
                  responseNfce?.response.codigo === 'erro_validacao_schema' &&
                  responseNfce?.response.erros &&
                  responseNfce?.response.erros.map((e) => (
                    <p> - {e.mensagem}</p>
                  ))}
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={() => setNFWarning(false)}
              style={{ background: '#dc3545', margin: '0 auto' }}
              title="Ok"
            >
              OK
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </Content>
  );
}

export default React.memo(TableAvailable);
